import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import LabOffering from "@/pages/LabOffering";

export const Route = createFileRoute("/en/services/lab-services/qp-release-and-eu-import")({
  head: () => buildRouteHead("/en/services/lab-services/qp-release-and-eu-import"),
  component: LabOffering,
});

